"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizationsViewModel = organizationsViewModel;
const organization_1 = require("./organization");
function organizationsViewModel(organizations, baseUrl) {
    return organizations?.map((organization) => (0, organization_1.organizationViewModel)(organization, baseUrl)) ?? [];
}
